import { render, staticRenderFns } from "./SmallParts.vue?vue&type=template&id=151fd652&scoped=true&"
import script from "./SmallParts.vue?vue&type=script&lang=js&"
export * from "./SmallParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151fd652",
  null
  
)

export default component.exports